/**
 * /messages (index) — Phase 4a empty state shown when no conversation is
 * selected.
 */

import { createFileRoute } from '@tanstack/react-router'

import { EmptyState } from '@/features/chat/components/EmptyState'

export const Route = createFileRoute('/messages/')({
  component: MessagesIndexComponent,
})

function MessagesIndexComponent() {
  return <EmptyState />
}
